export default __webpack_public_path__ + "static/media/blog-img64.58f2f0b3.jpg";